import { render, staticRenderFns } from "./BonusLevels.vue?vue&type=template&id=37c44d0c&scoped=true&"
import script from "./BonusLevels.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BonusLevels.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BonusLevels.vue?vue&type=style&index=0&id=37c44d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c44d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c44d0c')) {
      api.createRecord('37c44d0c', component.options)
    } else {
      api.reload('37c44d0c', component.options)
    }
    module.hot.accept("./BonusLevels.vue?vue&type=template&id=37c44d0c&scoped=true&", function () {
      api.rerender('37c44d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/BonusLevels.vue"
export default component.exports